import { withPrefix } from "gatsby";

export const Icons = {
  add_small: withPrefix("/icons/add_small.svg"),
  arrow_up: withPrefix("/icons/arrow_up.svg"),
  back_small: withPrefix("/icons/iycf-icons/small/dark/back.svg"),
  bookmark_small: withPrefix("/icons/bookmark_small.svg"),
  calendar_small: withPrefix("/icons/iycf-icons/small/dark/calendar.svg"),

  cancel_light: withPrefix("/icons/cancel_light.svg"),
  cancel_normal: withPrefix("/icons/cancel_normal.svg"),
  cancel_red_bg_white: withPrefix("/icons/cancel_red_bg_white.svg"),
  cancel_large_light: withPrefix("/icons/iycf-icons/large/light/close.svg"),

  categories_large_white: withPrefix("/icons/categories_large_white.svg"),
  categories_large: withPrefix("/icons/categories_large.svg"),
  categories_small_white: withPrefix("/icons/categories_small_white.svg"),
  categories_small: withPrefix("/icons/iycf-icons/small/dark/categories.svg"),

  chevronDown_large_white: withPrefix("/icons/chevronDown_large_white.svg"),
  chevronDown_large: withPrefix(
    "/icons/iycf-icons/large/dark/chevron_down.svg"
  ),
  chevronDown_small_white: withPrefix("/icons/chevronDown_small_white.svg"),
  chevronDown_small: withPrefix(
    "/icons/iycf-icons/small/dark/chevron_down.svg"
  ),

  chevronUp_large_white: withPrefix("/icons/chevronUp_large_white.svg"),
  chevronUp_large: withPrefix("/icons/iycf-icons/large/dark/chevron_up.svg"),
  chevronUp_small_white: withPrefix("/icons/chevronUp_small_white.svg"),
  chevronUp_small: withPrefix("/icons/iycf-icons/small/dark/chevron_up.svg"),

  cite_small: withPrefix("/icons/cite_small.svg"),
  close_small: withPrefix("/icons/iycf-icons/small/dark/close.svg"),
  compass_small: withPrefix("/icons/iycf-icons/small/dark/compass.svg"),
  contentType_small: withPrefix("/icons/iycf-icons/small/dark/contenttype.svg"),
  copy_small: withPrefix("/icons/iycf-icons/small/dark/copy.svg"),
  corner_arrow_small: withPrefix(
    "/icons/iycf-icons/small/dark/corner_arrow.svg"
  ),
  download_small: withPrefix("/icons/iycf-icons/small/dark/download.svg"),
  download_small_white: withPrefix(
    "/icons/iycf-icons/small/light/download.svg"
  ),
  dropdown_small: withPrefix("/icons/iycf-icons/small/dark/dropdown.svg"),

  edit_small: withPrefix("/icons/iycf-icons/small/dark/edit.svg"),
  email_large_white: withPrefix("/icons/email_large_white.svg"),
  email_large: withPrefix("/icons/email_large.svg"),
  email_small_white: withPrefix("/icons/email_small_white.svg"),
  email_small: withPrefix("/icons/iycf-icons/small/dark/email.svg"),

  externalLink_small: withPrefix(
    "/icons/iycf-icons/small/dark/externallink.svg"
  ),

  eye_small: withPrefix("/icons/eye_small.svg"),
  hidden_small: withPrefix("/icons/hidden_small.svg"),

  image_small: withPrefix("/icons/image_small.svg"),

  facebook_small: withPrefix("/icons/iycf-icons/small/dark/facebook.svg"),
  favicon: withPrefix("/icons/favicon.png"),

  file_minus_small: withPrefix("/icons/iycf-icons/small/dark/file_minus.svg"),
  file_plus_small: withPrefix("/icons/iycf-icons/small/dark/file_plus.svg"),
  file_text_small: withPrefix("/icons/iycf-icons/small/dark/file_text.svg"),

  filter_small: withPrefix("/icons/iycf-icons/small/dark/filter.svg"),
  filter_small_active: withPrefix("/icons/iycf-icons/small/dark/filter.svg"),

  filter_arrow: withPrefix("/icons/iycf-icons/filter_arrow.svg"),

  film: withPrefix("/icons/iycf-icons/small/dark/film.svg"),

  hash_small: withPrefix("/icons/iycf-icons/small/dark/hash.svg"),
  house_small: withPrefix("/icons/iycf-icons/small/dark/house.svg"),

  lang_large_white: withPrefix("/icons/lang_large_white.svg"),
  lang_large: withPrefix("/icons/lang_large.svg"),
  lang_small_white: withPrefix("/icons/iycf-icons/small/light/lang.svg"),
  lang_small: withPrefix("/icons/iycf-icons/small/dark/lang.svg"),

  library_large_white: withPrefix("/icons/library_large_white.svg"),
  library_large: withPrefix("/icons/iycf-icons/large/dark/library.svg"),
  library_small_white: withPrefix("/icons/iycf-icons/small/light/library.svg"),
  library_small: withPrefix("/icons/iycf-icons/small/dark/library.svg"),
  library_small_grey: withPrefix("/icons/library_small_grey.svg"),

  link_large_white: withPrefix("/icons/link_large_white.svg"),
  link_large: withPrefix("/icons/link_large.svg"),
  link_small_white: withPrefix("/icons/link_small_white.svg"),
  link_small: withPrefix("/icons/iycf-icons/small/dark/link.svg"),

  linkedin_small: withPrefix("/icons/iycf-icons/small/dark/linkedin.svg"),

  logout_small: withPrefix("/icons/iycf-icons/small/dark/logout.svg"),

  lock_small: withPrefix("/icons/iycf-icons/small/dark/lock.svg"),

  menu_large_white: withPrefix("/icons/menu_large_white.svg"),
  menu_large: withPrefix("/icons/iycf-icons/large/dark/menu.svg"),
  menu_small_white: withPrefix("/icons/menu_small_white.svg"),
  menu_small: withPrefix("/icons/menu_small.svg"),

  minus_gray: withPrefix("/icons/minus_gray.svg"),
  minus_white: withPrefix("/icons/minus_white.svg"),

  more_large_white: withPrefix("/icons/more_large_white.svg"),
  more_large: withPrefix("/icons/iycf-icons/large/dark/more.svg"),
  more_small_white: withPrefix("/icons/more_small_white.svg"),
  more_small: withPrefix("/icons/iycf-icons/small/dark/more.svg"),

  next_large: withPrefix("/icons/next_large.svg"),

  pin_large_white: withPrefix("/icons/pin_large_white.svg"),
  pin_large: withPrefix("/icons/iycf-icons/large/dark/pin.svg"),
  pin_small_white: withPrefix("/icons/pin_small_white.svg"),
  pin_small: withPrefix("/icons/iycf-icons/small/dark/pin.svg"),

  pdf: withPrefix("/icons/iycf-icons/icon_pdf.svg"),

  play_button: withPrefix("/icons/iycf-icons/play_btn.svg"),

  plus_white: withPrefix("/icons/plus_white.svg"),
  previous_large: withPrefix("/icons/previous_large.svg"),
  print_white: withPrefix("/icons/print_white.svg"),
  publisher_small: withPrefix("/icons/iycf-icons/small/dark/publisher.svg"),

  reCaptcha: withPrefix("/icons/reCaptcha.svg"),

  search_large_white: withPrefix("/icons/search_large_white.svg"),
  search_large: withPrefix("/icons/iycf-icons/large/dark/search.svg"),
  search_small_white: withPrefix("/icons/search_small_white.svg"),
  search_small: withPrefix("/icons/iycf-icons/small/dark/search.svg"),

  sensitive_content: withPrefix(
    "/icons/iycf-icons/small/dark/sensitive_content.svg"
  ),

  settings_small: withPrefix("/icons/iycf-icons/small/dark/settings.svg"),
  share_small: withPrefix("/icons/iycf-icons/small/dark/share.svg"),
  spinner: withPrefix("/icons/iycf-icons/spinner.svg"),
  subscribe_small: withPrefix("/icons/iycf-icons/small/dark/subscribe.svg"),
  subscribe_small_white: withPrefix(
    "/icons/iycf-icons/small/light/subscribe.svg"
  ),

  time_large_white: withPrefix("/icons/time_large_white.svg"),
  time_large: withPrefix("/icons/time_large.svg"),
  time_small_white: withPrefix("/icons/time_small_white.svg"),
  time_small: withPrefix("/icons/iycf-icons/small/dark/time.svg"),

  trash_small: withPrefix("/icons/iycf-icons/small/dark/trash.svg"),
  trash_small_white: withPrefix("/icons/iycf-icons/small/light/trash.svg"),

  twitter_small: withPrefix("/icons/iycf-icons/small/dark/twitter.svg"),

  user_small: withPrefix("/icons/iycf-icons/small/dark/user.svg"),
  user_default_image: withPrefix("/icons/user_default_image.svg"),

  upload_small: withPrefix("/icons/iycf-icons/small/dark/upload.svg"),
  upload_small_white: withPrefix("/icons/iycf-icons/small/light/upload.svg"),

  usaid_small: withPrefix("/icons/iycf-icons/USAID_small.svg"),
  whatsapp_small: withPrefix("/icons/iycf-icons/small/dark/whatsapp.svg"),
  ife_logo: withPrefix("/icons/iycf-icons/IFE_logo.png"),
  path_logo: withPrefix("/icons/iycf-icons/PATH_logo.png"),
  sfc_logo: withPrefix("/icons/iycf-icons/sfc-logo.png"),
  aah_logo: withPrefix("/icons/iycf-icons/aah_logo.png"),
  enn_logo: withPrefix("/icons/iycf-icons/enn_logo.png"),
  stc_logo: withPrefix("/icons/iycf-icons/stc_logo.svg"),
};
